var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuyInvestment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6161_2281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 11H3C2.447 11 2 10.552 2 10V2H0V0H3C3.553 0 4 0.448 4 1V9H12.246L13.674 4H12V2H15C15.917 2 16.048 2.973 15.962 3.275L13.962 10.275C13.839 10.704 13.446 11 13 11Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 16C4.10457 16 5 15.1046 5 14C5 12.8954 4.10457 12 3 12C1.89543 12 1 12.8954 1 14C1 15.1046 1.89543 16 3 16Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 16C14.1046 16 15 15.1046 15 14C15 12.8954 14.1046 12 13 12C11.8954 12 11 12.8954 11 14C11 15.1046 11.8954 16 13 16Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5V1H7V5H5L8 8L11 5H9Z",
    fill: "#979797"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6161_2281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyInvestment);
export default __webpack_public_path__ + "static/media/buy-investment.747a81a28a96a1fa3974c2396cd164e7.svg";
export { ForwardRef as ReactComponent };